























import Vue from "vue";
import { Component } from "vue-property-decorator";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-cal/dist/vuecal.css";
import "@/assets/scss/omnicasa.scss";
import { sendMessage } from "./_utils";
import moment from "moment";

@Component({
  components: {}
})
export default class App extends Vue {
  get buttonBackColor() {
    return "#" + this.$route.query.buttonBackColor || "";
  }

  get buttonFontColor() {
    return "#" + this.$route.query.buttonFontColor || "";
  }

  get showBackButton() {
    if (this.$route.name == "contact-appointment") {
      return true;
    }
    return false;
  }

  get styleApp() {
    let style = "";
    if (this.$route.query.fontColor) {
      style += `color: ${this.$route.query.fontColor};`;
    }
    if (this.$route.query.font) {
      style += `font-family: ${this.$route.query.font};`;
    }
    if (this.$route.query.fontSize) {
      style += `font-size: ${this.$route.query.fontSize};`;
    }
    return style;
  }

  handleRouterBack() {
    this.$router.back();
  }

  handleCloseModal() {
    sendMessage({ type: "hide-modal", mess: "hide-modal" });
  }

  mounted() {
    const vm = this as any;
    if (vm.$route.query.language) {
      vm.$i18n.locale = vm.$route.query.language;
    } else {
      vm.$i18n.locale = "nl";
    }
    if (vm.$route.query.linkCss) {
      const cssLink = document.createElement("link");
      cssLink.href = vm.$route.query.linkCss;
      cssLink.rel = "stylesheet";
      cssLink.type = "text/css";
      window.document.head.appendChild(cssLink);
    }
  }
}
